import FotoscapesURL from '../fotoscape/FotoscapesURL';
import { fetchGetUrl } from '../utilities/net';
import dailyTopMinimalPartial from '../shared/templates/layouts/daily_top_minimal';
import NewPersonalize from '../fotoscape/helpers/personalize';
import { removeAllMarkdown } from '../fotoscape/fotoscape-markdown';
import { ITrendingContent } from '../../scripts/interfaces'

const language = document.documentElement.lang

export const fetchFotoscapesTranding = async (category = 'all'): Promise<ITrendingContent[]> => {
  let url = `${FotoscapesURL.getBaseURL()}/wp/v1/trending/${category}?ckey=${FotoscapesURL.getKey()}`

  const response: any = await fetchGetUrl(url)
  const { data } = response
  return data.topics
}

const initTrendingContent = async () => {
  if(window.mp_globals.trending_content_config) {
    const { blocks } = window.mp_globals.trending_content_config;

    for (const block of blocks) {
      const blockEl = document.querySelector(`#${block.block_id}`)

      try {
        const data = await fetchFotoscapesTranding(block.category);
        const trendingData = data.slice(0, 5).map(trending => {
          return trending.items[0]
        });

        trendingData.forEach(({ title, brandLogoDark, brandLogo, previews, summary, sourceLink }, index) => {
          const instance = NewPersonalize()

          const formatData = {
            title: instance.chooseText(title, language),
            publisherLogo: brandLogoDark,
            thumbnailUrl: previews[0].link,
            description: removeAllMarkdown(instance.chooseText(summary, language)),
            publisherDarkLogo: brandLogo,
            link: sourceLink,
            index: index + 1
          }

          const layout = dailyTopMinimalPartial(formatData);
          const dummyElement = document.createElement('div')

          dummyElement.innerHTML = layout;

          const blockMain = blockEl.querySelector('.block__main');

          blockMain.appendChild(dummyElement)
        })
      } catch (e) {
        console.error(e);
      }
      blockEl.querySelector('.block--daily-top-minimal').classList.remove('skeleton')
    }
  }
}

export default initTrendingContent;